import styled from 'styled-components'

type Props = {
  background: string
  color: string
  border: string
}

export const Container = styled.div<Props>`
  display: flex;
  flex-direction: row;
  position: relative;
  overflow: hidden;
  background-color: ${(props) => props.background};
  border: 1px solid ${(props) => props.border};
  border-radius: 6px;
  max-height: 25%;
  min-height: 4rem;
  cursor: pointer;
`
